import { useEffect } from "react";
import { useLocation, useNavigate, Outlet } from "react-router-dom";
import { WebStorageClient } from "../../clients/webStorage.client";
import { WEB_STORAGE_KEYS } from "../../clients/clients.constants";
import { useSelector } from "react-redux";
import { roleConfig } from "../../clients/clients.constants";

function ProtectedRoute({ allowedPaths }) {
  const location = useLocation();
  const navigate = useNavigate();

  const userStore = useSelector((state) => state.user);

  useEffect(() => {
    const user = WebStorageClient.getByKey(WEB_STORAGE_KEYS.AUTH_USER);

    // If no user is found, clear storage and redirect to login
    if (!userStore?.user?.roles) {
      localStorage.clear();
      sessionStorage.clear();
      if (!location.pathname.includes("login")) {
        alert("Your session has expired. Please log in again.");
      }
      navigate("/login", { replace: true });
      return;
    }

    const userRoles = userStore?.user?.roles;
    const currentPath = location.pathname.replace(/\/+$/, "").toLowerCase(); // Normalize path to lowercase and remove trailing slashes

    // Aggregate allowed paths and default redirect across all roles
    let defaultRedirect = "/login";
    let aggregatedAllowedPaths = [];

// Check if the user has the "admin" role first
    if (userRoles.includes("admin") && roleConfig["admin"]) {
      defaultRedirect = roleConfig["admin"].defaultRedirect;
      aggregatedAllowedPaths = roleConfig["admin"].allowedPaths;
    } else {
      // Otherwise, iterate over user roles to find matching role settings
      userRoles.forEach((role) => {
        const roleSettings = roleConfig[role];
        if (roleSettings) {
          aggregatedAllowedPaths = [
            ...aggregatedAllowedPaths,
            ...roleSettings.allowedPaths,
          ];
          // If defaultRedirect is still set to "/login", update it with the first valid defaultRedirect found
          if (defaultRedirect === "/login") {
            defaultRedirect = roleSettings.defaultRedirect;
          }
        }
      });
    }
    console.log('defaultRedirect',defaultRedirect);

    // Normalize aggregated allowed paths for comparison
    const normalizedAllowedPaths = aggregatedAllowedPaths.map((path) =>
      path.replace(/\/+$/, "").toLowerCase()
    );

    const isAllowed =
      normalizedAllowedPaths.includes("*") || // Allow all paths for admins
      normalizedAllowedPaths.includes(currentPath); // Explicitly allowed paths

    // Handle unauthorized access
    if (!isAllowed) {
      if (currentPath === defaultRedirect.replace(/\/+$/, "").toLowerCase()) {
        // Avoid infinite redirect loop
        alert(
          `You don't have permission to access the page: ${currentPath}. Please contact support.`
        );
        return;
      }
      if (currentPath !== defaultRedirect) {
        // Show alert only if the user is not already being redirected
        alert(
          `You don't have permission to access the page: ${currentPath}. Redirecting to your default page.`
        );
      }
      navigate(defaultRedirect, { replace: true });
      return;
    }
  }, [location.pathname, navigate, userStore]);

  return <Outlet />;
}

export default ProtectedRoute;
